import { ca } from '@cian/analytics';

export const onRecommendationsSectionShowAnalytic = (
  products: { id: number; position: number }[],
  siteType: 'mobile' | 'tablet' | 'desktop',
) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_carousel',
    action: 'show_sopr',
    label: 'nb_recomend_jk',
    page: {
      pageType: 'Home',
      siteType,
      extra: {
        products,
      },
    },
  });
};

export const onShowAllClickAnalytic = (siteType: 'mobile' | 'tablet' | 'desktop') => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_carousel',
    action: 'click_sopr',
    label: 'nb_recomend_all',
    page: {
      pageType: 'Home',
      siteType,
    },
  });
};

export const onCardClickAnalytic = ({
  newbuildingId,
  position,
  siteType,
}: {
  newbuildingId: number;
  position: number;
  siteType: 'mobile' | 'tablet' | 'desktop';
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_carousel',
    action: 'click_sopr',
    label: 'nb_recomend_jk',
    page: {
      pageType: 'Home',
      siteType,
      extra: { to_object: newbuildingId, object_type: 'jk', position },
    },
  });
};
